<template>
  <PageListLayout
    icon="mdi-text-box-check-outline"
    title="DANH SÁCH HÓA ĐƠN"
    subTitle="Danh sách hóa đơn"
    useAdd
    titleAdd="Tạo mới hóa đơn"
    @add="createItem"
  >
    <template slot="filter">
      <v-text-field
        append-icon="mdi-magnify"
        v-model="search"
        label="Tìm kiếm"
        clearable
        single-line
        outlined
        dense
        hide-details
      ></v-text-field>
    </template>
    <CustomTable
      :headers="headers"
      :items="tableData"
      :page.sync="page"
      :items-per-page="itemsPerPage"
      hide-default-footer
      :loading="loading"
      loading-text="Đang tải dữ liệu ..."
      :pageCount="pageCount"
      @change-page="changePage"
      classPaging="pt-2"
    >
      <template v-slot:[`item.icon`]="{ item }">
        <v-icon>{{ item.icon }}</v-icon>
      </template>
      <template v-slot:[`item.order`]="{ item }">
        <span>{{
          item.parent ? item.parent.order + "-" + item.order : item.order
        }}</span>
      </template>
      <template v-slot:[`item.status`]="{ item }">
        <span>{{ handleStatus(item.status) }}</span>
      </template>
      <template v-slot:[`item.action`]="{ item }">
        <v-menu>
          <template v-slot:activator="{ on, attrs }">
            <v-btn icon v-bind="attrs" v-on="on">
              <v-icon color="textColor">mdi-dots-vertical</v-icon>
            </v-btn>
          </template>
          <v-list>
            <v-list-item @click="editItem(item)">
              <v-list-item-title>
                <v-icon class="mr-2"> mdi-pencil </v-icon>
                Cập nhật</v-list-item-title
              >
            </v-list-item>
            <v-list-item @click="deleteItem(item)">
              <v-list-item-title>
                <v-icon class="mr-2"> mdi-delete </v-icon>
                Xóa hoá đơn</v-list-item-title
              >
            </v-list-item>
          </v-list>
        </v-menu>
      </template>
    </CustomTable>
    <create-edit ref="form" @on-done="getAllList"></create-edit>
  </PageListLayout>
</template>
<script>
import API from "@/api/hoadon";
import CreateEdit from "./create-edit";
import { debounce } from "lodash";
import {status} from "@/constants/hoadon";
export default {
  components: { CreateEdit },
  data() {
    return {
      status,
      page: 1,
      pageCount: 1,
      itemsPerPage: 10,
      tableData: [],
      btnLoading: false,
      menu: {},
      loading: false,
      search: "",
      headers: [
        // { text: "STT", width: "100", sortable: false },
        // { text: "Icon", value: "icon", sortable: false },
        {
          text: "Công ty",
          align: "start",
          sortable: false,
          value: "company_out_name",
        },
        { text: "Công ty mua", value: "company_in_name" },
        { text: "Số HĐ", value: "bill_no" },
        { text: "Ngày HĐ", value: "bill_date" },
        { text: "Số tiền", value: "price" },
        { text: "Số tờ khai nhập", value: "" },
        { text: "Trạng thái", value: "status" },
        {
          text: "Hành động",
          value: "action",
          sortable: false,
          align: "center",
          width: "150",
        },
      ],
    };
  },
  computed: {},
  created() {
    this.getAllList();
  },
  watch: {
    search: debounce(async function (val) {
      this.loading = true;
      let data = await API.list({
        page: this.page,
        perPage: this.itemsPerPage,
        search: val,
      });
      this.loading = false;
      this.tableData = data.data.data;
      this.pageCount = data.data.last_page;
    }, 300),
  },
  methods: {
    async getAllList() {
      this.loading = true;
      let data = await API.list({
        page: this.page,
        perPage: this.itemsPerPage,
      });
      this.loading = false;
      this.tableData = data.data.data;
      this.pageCount = data.data.last_page;
    },
    handleStatus(id){
      let find = this.status.find(item => item.id == id);
      return find ? find.name : ""
    },
    changePage(val) {
      this.page = val;
      this.getAllList();
    },
    editItem(item) {
      this.$refs.form.showFormEdit(item);
    },
    async deleteItem(item) {
      this.$confirmBox.show({
        title: "Xóa Hoá Đơn",
        width: 500,
        body:
          "Bạn có chắc chắn muốn xóa hoá đơn",
        action: () => API.destroy(item.id ),
        onDone: this.getAllList,
        disableMessage: true
      });
    },
    createItem() {
      this.$refs.form.showFormAdd();
    },
  },
};
</script>
